module.exports = __webpack_public_path__ + "static/img/Tesi-Niu.1608591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Tesi-Niu.jpg
// module id = xvth
// module chunks = 0